import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import vuetify from './plugins/vuetify';
import router from './plugins/router';
import i18n from './i18n';
import Capitalize from "./comunes/filtros/Capitalize";
import FormatearFechas from "./comunes/filtros/FormatearFechas";
import FormatearTimestampt from "./comunes/filtros/FormatearTimestampt";
import store from "./store/store-app";
import VueApexCharts from 'vue-apexcharts';
import VueGtag from "vue-gtag";

Vue.use(VueApexCharts);
Vue.use(require('vue-moment'));

Vue.component('apexChart', VueApexCharts);

Vue.use(VueGtag, {
    config: {id: process.env.VUE_APP_ANALYTICS_ID}
}, router);

Vue.config.productionTip = false;
Vue.filter('capitalize', Capitalize);
Vue.filter('formatDate', FormatearFechas);
Vue.filter('formatTimestamp', FormatearTimestampt);

new Vue({
    vuetify,
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');
